import { useUTCDate } from "../../../../../shared/infrastructure/ui/hooks/use-utc-date";

export const useDatesLocation = (
  earlyDate: string,
  lateDate: string
): [string, string | undefined] => {
  const { dateFromUTC } = useUTCDate();

  // eslint-disable-next-line functional/no-let
  let dates: [string | undefined, string | undefined] = [earlyDate, lateDate];

  if (!earlyDate) {
    dates = [undefined, undefined];
  } else if (!lateDate || earlyDate === lateDate) {
    dates = [earlyDate, undefined];
  } else if (
    dateFromUTC(earlyDate).format("MM/DD/YYYY") ===
    dateFromUTC(lateDate).format("MM/DD/YYYY")
  ) {
    return [
      dateFromUTC(earlyDate).format("MM/DD/YYYY"),
      `${dateFromUTC(earlyDate).format("HH:mm")} - ${dateFromUTC(
        lateDate
      ).format("HH:mm")}`,
    ];
  }

  return [
    dates[0] ? dateFromUTC(dates[0]).format("MM/DD/YYYY HH:mm") : "- -",
    dates[1] ? dateFromUTC(dates[1]).format("MM/DD/YYYY HH:mm") : undefined,
  ];
};
